import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const showReportModal = createAction(`${actionKey}.SHOW`, (deviation)=>({
        deviation
    }));
export const hideDeviation = createAction(`${actionKey}.HIDE_DEVIATION`, (deviationId)=>deviationId);
export const hideDeviationSuccess = createAction(`${actionKey}.HIDE_DEVIATION_SUCCESS`, (deviationId)=>deviationId);
export const hideDeviationFail = createAction(`${actionKey}.HIDE_DEVIATION_FAIL`, (deviationId)=>deviationId);
export const unhideDeviation = createAction(`${actionKey}.UNHIDE_DEVIATION`, (deviationId)=>deviationId);
export const unhideDeviationSuccess = createAction(`${actionKey}.UNHIDE_DEVIATION_SUCCESS`, (deviationId)=>deviationId);
export const unhideDeviationFail = createAction(`${actionKey}.UNHIDE_DEVIATION_FAIL`, (deviationId)=>deviationId);
export const blockDeviationAuthor = createAction(`${actionKey}.BLOCK_AUTHOR`, (user, deviationId)=>({
        user,
        deviationId
    }));
export const unblockDeviationAuthor = createAction(`${actionKey}.UNBLOCK_AUTHOR`, (userId, deviationId)=>({
        userId,
        deviationId
    }));
